export interface ContentBlock {
  type: 'paragraph' | 'image' | 'quote' | 'heading';
  text?: string;
  src?: string;
  caption?: string;
}

export interface Article {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  categoryName: string;
  sub: string;
  source: string;
  author: string;
  publishedAt: string;
  views: number;
  comments: number;
  tags: string[];
  content: ContentBlock[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '顶流男星深夜密会同框实锤，全程包裹仍被认出',
    summary: '凌晨两点，某顶流男星被拍到与神秘女子同车离开市中心酒店，两人刻意错开下车仍难逃镜头。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20night%20city%20scene%20with%20blurred%20bokeh%20lights%2C%20dramatic%20magenta%20and%20orange%20glow%2C%20abstract%20moody%20atmosphere%2C%20cinematic%20entertainment%20news%20aesthetic%2C%20no%20recognizable%20faces&width=800&height=600&seq=gossip-cover-a1&orientation=landscape',
    category: 'scandal',
    categoryName: '明星绯闻',
    sub: '恋情曝光',
    source: '深夜蹲点小组',
    author: '爆料君',
    publishedAt: '2026-10-12 08:40',
    views: 486230,
    comments: 9821,
    tags: ['顶流', '密会', '同框', '恋情'],
    content: [
      { type: 'paragraph', text: '据多位目击者透露，这位近期作品接连爆红的男星，于前日凌晨低调现身市中心一家会员制酒店，全程佩戴棒球帽与口罩，仍被认出。' },
      { type: 'quote', text: '他们刻意分两趟下车，但车辆的型号和车牌尾号太显眼了，基本上没法洗。' },
      { type: 'paragraph', text: '更值得注意的是，女方并非圈内素人，而是与其新剧合作过的工作人员。两人的行程轨迹在近一个月内出现多次重合，情人节当天的时间线更是几乎完全对齐。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Abstract%20nighttime%20approach%20to%20a%20luxury%20hotel%20entrance%20with%20warm%20orange%20lighting%20and%20magenta%20highlights%2C%20stylized%20blurred%20figures%2C%20editorial%20gossip%20magazine%20look%2C%20no%20clear%20faces&width=800&height=500&seq=gossip-body-a1&orientation=landscape', caption: '凌晨两点的酒店入口，监控视角已被涂抹处理' },
      { type: 'paragraph', text: '截至发稿，双方工作室均未对此作出回应。而粉丝后援会已经开始\"公关式\"控评，相关话题的讨论量在数小时内突破两亿。' },
      { type: 'heading', text: '时间线复盘' },
      { type: 'paragraph', text: '从新剧开机到庆功宴，两人被拍到同框的次数已经达到四次。业内人士分析，如果消息坐实，将直接影响到男星手上数个尚未官宣的商业代言。' },
    ],
  },
  {
    id: 'a2',
    title: '双栖女演员被曝已低调分手，社交账号清空合照',
    summary: '曾被全网祝福的\"荧幕情侣\"疑似走到尽头，女方深夜清空与男方的全部互动记录。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20melancholic%20portrait%20silhouette%20of%20a%20woman%20against%20warm%20gray%20background%20with%20soft%20magenta%20rim%20light%2C%20minimal%20editorial%20entertainment%20poster%20style%2C%20no%20recognizable%20features&width=800&height=600&seq=gossip-cover-a2&orientation=landscape',
    category: 'scandal',
    categoryName: '明星绯闻',
    sub: '分手传闻',
    source: '圈内线人',
    author: '瓜田观察',
    publishedAt: '2026-10-12 07:15',
    views: 342100,
    comments: 6410,
    tags: ['分手', '荧幕情侣', '清空动态'],
    content: [
      { type: 'paragraph', text: '这对曾被媒体称为\"年度最佳荧幕情侣\"的搭档，近日被粉丝发现女方已悄悄清空了社交账号上所有与男方的合照与互动。' },
      { type: 'paragraph', text: '有接近两人团队的人士透露，双方因为工作档期长期异地，感情在近三个月内急速降温，最终选择和平分开。' },
      { type: 'quote', text: '没有撕破脸，就是不合适了。两人现在连共同好友的聚会都尽量避免同场。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Two%20empty%20chairs%20facing%20away%20in%20a%20softly%20lit%20studio%20with%20warm%20amber%20backdrop%20and%20faint%20magenta%20gradient%2C%20symbolic%20editorial%20concept%20photo%2C%20minimal%20composition&width=800&height=500&seq=gossip-body-a2&orientation=landscape', caption: '两人共同的粉丝应援物已被悄然撤下' },
      { type: 'paragraph', text: '值得注意的是，女方的新剧下个月即将开播，此时爆出分手传闻，也让不少网友猜测是否为宣传期的\"话题操作\"。' },
    ],
  },
  {
    id: 'a3',
    title: '豪门婚变传闻持续升级，双方家族疑似介入调解',
    summary: '结婚不到三年的豪门夫妻被曝感情破裂，知情人称两边家族已多次私下会面。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20luxury%20mansion%20facade%20at%20dusk%20with%20warm%20golden%20windows%20and%20deep%20magenta%20sky%2C%20editorial%20news%20aesthetic%2C%20cinematic%20mood%2C%20clean%20composition&width=800&height=600&seq=gossip-cover-a3&orientation=landscape',
    category: 'scandal',
    categoryName: '明星绯闻',
    sub: '婚姻风波',
    source: '财经娱乐交叉口',
    author: '深扒组',
    publishedAt: '2026-10-11 21:30',
    views: 298450,
    comments: 5233,
    tags: ['豪门', '婚变', '家族'],
    content: [
      { type: 'paragraph', text: '这场从年初就开始发酵的婚变传闻，近日随着一份疑似财产分割文件的流出而再度升温。' },
      { type: 'paragraph', text: '据接近双方家族的人士称，两家已就共同持股的公司股权进行过多轮协商，但尚未达成一致。' },
      { type: 'quote', text: '这已经不只是感情问题了，牵扯到的商业版图太大，谁都不会轻易松口。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Elegant%20close%20up%20of%20signed%20documents%20and%20a%20fountain%20pen%20on%20a%20marble%20desk%20with%20warm%20amber%20lighting%20and%20soft%20magenta%20shadow%2C%20editorial%20business%20news%20still%20life&width=800&height=500&seq=gossip-body-a3&orientation=landscape', caption: '疑似财产相关文件在网络流传（已做处理）' },
      { type: 'paragraph', text: '目前双方经纪团队仍保持沉默。有分析认为，无论结果如何，这场风波都将成为年度最受关注的娱乐财经话题之一。' },
    ],
  },
  {
    id: 'a4',
    title: '新晋小花私下约会被拍，男方身份引发全网竞猜',
    summary: '刚凭一部甜宠剧走红的小花，被拍到与一男子在商场地下车库牵手上车。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20underground%20parking%20garage%20with%20warm%20orange%20fluorescent%20lights%20and%20magenta%20reflections%2C%20cinematic%20blurred%20figures%20in%20distance%2C%20editorial%20gossip%20aesthetic%2C%20moody&width=800&height=600&seq=gossip-cover-a4&orientation=landscape',
    category: 'scandal',
    categoryName: '明星绯闻',
    sub: '私下约会同框',
    source: '同城目击',
    author: '街拍小分队',
    publishedAt: '2026-10-11 18:05',
    views: 265780,
    comments: 4120,
    tags: ['小花', '牵手', '车库'],
    content: [
      { type: 'paragraph', text: '视频显示，两人从商场地库一同走出，女方全程低头，男子则主动为其拉开车门，动作十分自然。' },
      { type: 'quote', text: '那个男生很高，穿着很普通，但一看就是经常照顾她的那种关系。' },
      { type: 'paragraph', text: '网友很快展开\"人肉\"，发现男子疑似是某新锐品牌的创始人，两人此前在品牌活动上有过公开同框的历史。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Warm%20city%20street%20at%20night%20with%20soft%20orange%20streetlights%20and%20magenta%20neon%20reflections%20on%20wet%20asphalt%2C%20stylized%20empty%20scene%2C%20editorial%20urban%20news%20look&width=800&height=500&seq=gossip-body-a4&orientation=landscape', caption: '事发地附近的街景' },
      { type: 'paragraph', text: '截至发稿，女方团队表示\"艺人私事不便回应\"，这被不少网友解读为\"默认\"。' },
    ],
  },
  {
    id: 'a5',
    title: '年度大制作古装剧正式定档，主演阵容首次曝光',
    summary: '投资超五亿的古装巨制定档下月，双男主阵容与特效团队一同官宣，预约量破纪录。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20palace%20gate%20at%20sunset%20with%20warm%20golden%20light%20and%20deep%20magenta%20clouds%2C%20cinematic%20epic%20drama%20poster%20aesthetic%2C%20clean%20symmetrical%20composition&width=800&height=600&seq=gossip-cover-a5&orientation=landscape',
    category: 'news',
    categoryName: '最新新闻',
    sub: '影视动态',
    source: '官方发布',
    author: '娱乐前哨',
    publishedAt: '2026-10-11 14:20',
    views: 401560,
    comments: 7230,
    tags: ['古装', '定档', '大制作'],
    content: [
      { type: 'paragraph', text: '这部备受期待的古装大剧终于官宣定档，将于下月登陆平台，同步公布的首支预告片播放量在三小时内突破五千万。' },
      { type: 'paragraph', text: '从预告来看，剧组在服化道与实景搭建上投入巨大，多处场景为全实景拍摄，特效镜头占比超过三成。' },
      { type: 'quote', text: '我们想要的是\"能闻到风声\"的质感，所以坚持了九个月的实景拍摄。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20traditional%20Chinese%20costume%20details%20with%20rich%20burgundy%20and%20gold%20embroidery%20on%20warm%20neutral%20background%2C%20editorial%20period%20drama%20still%20life%2C%20elegant&width=800&height=500&seq=gossip-body-a5&orientation=landscape', caption: '剧中主要服饰细节首次曝光' },
      { type: 'paragraph', text: '业内预测，该剧有望冲击本年度古装剧收视与口碑双重纪录。' },
    ],
  },
  {
    id: 'a6',
    title: '综艺名场面引爆热搜，嘉宾当场情绪失控',
    summary: '最新一期综艺中，嘉宾因游戏环节意外翻脸，节目组紧急剪辑仍难掩火药味。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20colorful%20variety%20show%20studio%20stage%20with%20warm%20orange%20spotlights%20and%20magenta%20ambient%20glow%2C%20empty%20stage%20set%20pieces%2C%20editorial%20entertainment%20aesthetic%2C%20no%20people&width=800&height=600&seq=gossip-cover-a6&orientation=landscape',
    category: 'news',
    categoryName: '最新新闻',
    sub: '综艺资讯',
    source: '节目组',
    author: '综艺雷达',
    publishedAt: '2026-10-11 11:00',
    views: 233900,
    comments: 3880,
    tags: ['综艺', '名场面', '热搜'],
    content: [
      { type: 'paragraph', text: '最新一期节目播出后，一段嘉宾当场\"黑脸\"的画面迅速登上热搜榜首，相关话题阅读量在半天内破三亿。' },
      { type: 'quote', text: '当时气氛真的很僵，连主持人都不知道怎么接话，最后只能靠剪辑圆过去。' },
      { type: 'paragraph', text: '有现场观众透露，起因是游戏环节中的一次\"犯规\"判罚，双方各执一词，矛盾当场爆发。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20empty%20TV%20studio%20with%20warm%20amber%20lights%20and%20soft%20magenta%20haze%2C%20blurred%20production%20equipment%2C%20editorial%20television%20news%20aesthetic&width=800&height=500&seq=gossip-body-a6&orientation=landscape', caption: '节目录制现场（示意图）' },
      { type: 'paragraph', text: '节目组回应称\"剪辑还原了真实反应\"，但并未直接回应是否有人\"翻脸\"。' },
    ],
  },
  {
    id: 'a7',
    title: '实力歌手时隔三年携新专辑回归，首单即登顶',
    summary: '低调三年的实力派人气歌手突然发布回归物料，首支单曲上线两小时冲上热榜第一。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20music%20theme%20with%20flowing%20magenta%20and%20warm%20orange%20sound%20waves%20on%20deep%20charcoal%20background%2C%20editorial%20album%20cover%20aesthetic%2C%20modern%20minimal&width=800&height=600&seq=gossip-cover-a7&orientation=landscape',
    category: 'news',
    categoryName: '最新新闻',
    sub: '音乐资讯',
    source: '唱片公司',
    author: '音乐捕手',
    publishedAt: '2026-10-10 20:45',
    views: 187600,
    comments: 2990,
    tags: ['回归', '新专辑', '登顶'],
    content: [
      { type: 'paragraph', text: '三年前宣布\"暂别舞台\"的这位歌手，毫无预警地发布了全新专辑预告，首支单曲上线两小时便登顶多平台热榜。' },
      { type: 'paragraph', text: '据了解，整张专辑由本人参与全部词曲创作，并邀请到国际团队完成后期制作。' },
      { type: 'quote', text: '这三年我没有消失，我只是把自己重新写了一遍。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20recording%20studio%20control%20room%20with%20warm%20amber%20lighting%20and%20magenta%20LED%20accents%2C%20empty%20console%20and%20microphone%20in%20focus%2C%20editorial%20music%20news%20aesthetic&width=800&height=500&seq=gossip-body-a7&orientation=landscape', caption: '专辑录制现场（示意图）' },
      { type: 'paragraph', text: '粉丝纷纷留言\"青春回来了\"，演唱会门票预约通道也一度因流量过大而延迟开放。' },
    ],
  },
  {
    id: 'a8',
    title: '一线女星拿下国际奢牌全球代言，广告大片同步释出',
    summary: '该女星成为品牌史上首位中国籍全球代言人，全新广告大片在海外同步上线。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20luxury%20fashion%20campaign%20backdrop%20with%20elegant%20deep%20magenta%20drapery%20and%20warm%20golden%20spotlight%2C%20minimal%20editorial%20couture%20aesthetic%2C%20no%20people&width=800&height=600&seq=gossip-cover-a8&orientation=landscape',
    category: 'news',
    categoryName: '最新新闻',
    sub: '商业代言',
    source: '品牌官方',
    author: '时尚情报站',
    publishedAt: '2026-10-10 16:10',
    views: 176540,
    comments: 2210,
    tags: ['代言', '奢牌', '大片'],
    content: [
      { type: 'paragraph', text: '国际奢侈品牌正式官宣这位一线女星为全球代言人，这也是品牌历史上首次由中国人担任该级别的代言。' },
      { type: 'paragraph', text: '同步释出的广告大片以\"夜色与光\"为主题，取景于海外多处地标建筑，整体质感备受好评。' },
      { type: 'quote', text: '她身上有一种不费力气的贵气，这是我们选择她的重要原因。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20luxury%20perfume%20bottle%20and%20silk%20fabric%20on%20warm%20neutral%20surface%20with%20magenta%20and%20gold%20accents%2C%20editorial%20fashion%20still%20life%2C%20elegant%20minimal&width=800&height=500&seq=gossip-body-a8&orientation=landscape', caption: '品牌全新视觉物料（示意）' },
      { type: 'paragraph', text: '业内估算，此次代言的商业价值有望刷新同类合作纪录。' },
    ],
  },
  {
    id: 'a9',
    title: '独家爆料：剧组内幕曝光，临时换角风波始末',
    summary: '一部开拍在即的剧集突遭换角，知情人还原制片方与团队之间的博弈全过程。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20film%20set%20with%20warm%20orange%20work%20lights%20and%20magenta%20haze%2C%20empty%20director%20chair%20and%20camera%20rig%20in%20focus%2C%20editorial%20entertainment%20news%2C%20cinematic&width=800&height=600&seq=gossip-cover-a9&orientation=landscape',
    category: 'leak',
    categoryName: '热门爆料',
    sub: '独家爆料',
    source: '一线爆料人',
    author: '深喉',
    publishedAt: '2026-10-10 13:30',
    views: 219870,
    comments: 5210,
    tags: ['换角', '剧组', '内幕'],
    content: [
      { type: 'paragraph', text: '据多位剧组工作人员透露，这部开拍前一周的剧集在开机前夜突然更换了女主角，全组行程被迫推迟半个月。' },
      { type: 'quote', text: '通告都发出去了，海报都印好了，结果一夜之间全推翻，那种混乱你想象不到。' },
      { type: 'paragraph', text: '知情人称，换角的直接原因与档期协调失败有关，但也有人指出，双方在片酬与剧本修改上早有分歧。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20clapperboard%20and%20folded%20script%20on%20a%20warm%20wooden%20table%20with%20soft%20magenta%20and%20orange%20light%2C%20editorial%20film%20production%20still%20life%2C%20minimal&width=800&height=500&seq=gossip-body-a9&orientation=landscape', caption: '剧组通告单（已做处理）' },
      { type: 'paragraph', text: '截至目前，制片方与相关艺人团队均未就换角原因作出公开说明。' },
    ],
  },
  {
    id: 'a10',
    title: '圈内风向：顶流团队大洗牌，核心成员集体离职',
    summary: '多个消息源证实，一位顶流的经纪团队近日出现大规模人事变动，宣发核心集体出走。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20modern%20office%20at%20night%20with%20warm%20amber%20desk%20lamps%20and%20magenta%20city%20glow%20through%20windows%2C%20empty%20desks%2C%20editorial%20business%20news%20aesthetic%2C%20cinematic&width=800&height=600&seq=gossip-cover-a10&orientation=landscape',
    category: 'leak',
    categoryName: '热门爆料',
    sub: '圈内风向',
    source: '从业者爆料',
    author: '圈内观察',
    publishedAt: '2026-10-09 22:15',
    views: 164320,
    comments: 3140,
    tags: ['团队', '离职', '宣发'],
    content: [
      { type: 'paragraph', text: '据多位业内人士证实，这位常年霸榜的顶流最近经历了一轮团队\"大换血\"，负责宣发与商务的核心成员陆续离职。' },
      { type: 'paragraph', text: '有分析认为，这与艺人近期转型电影赛道、工作重心调整有直接关系。' },
      { type: 'quote', text: '不是闹掰，是方向变了。电影和流量的打法完全不一样，团队自然要重组。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20empty%20corporate%20meeting%20room%20with%20warm%20neutral%20tone%20and%20faint%20magenta%20accent%20light%2C%20editorial%20news%20photography%20aesthetic%2C%20clean&width=800&height=500&seq=gossip-body-a10&orientation=landscape', caption: '相关公司办公区（示意图）' },
      { type: 'paragraph', text: '此次变动是否会影响到艺人后续的资源接洽，目前仍是未知数。' },
    ],
  },
  {
    id: 'a11',
    title: '幕后花絮：一场吻戏拍了十七条，导演现场示范',
    summary: '备受关注的荧幕之吻背后，是导演亲自上阵示范与两位演员反复磨合的十七次拍摄。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20romantic%20film%20scene%20backdrop%20with%20warm%20sunset%20gradient%20magenta%20to%20orange%20and%20soft%20bokeh%2C%20editorial%20behind%20the%20scenes%20aesthetic%2C%20no%20people&width=800&height=600&seq=gossip-cover-a11&orientation=landscape',
    category: 'leak',
    categoryName: '热门爆料',
    sub: '幕后花絮',
    source: '片场花絮',
    author: '场记小张',
    publishedAt: '2026-10-09 19:40',
    views: 142870,
    comments: 2680,
    tags: ['吻戏', '幕后', '花絮'],
    content: [
      { type: 'paragraph', text: '这部年度爱情片的爆款片段\"天台之吻\"，近期释出花絮，两位主演自曝这场戏足足拍了十七条才过。' },
      { type: 'quote', text: '不是尴尬，是导演想要那种\"差一点点就够到\"的感觉，光打光就换了三种方案。' },
      { type: 'paragraph', text: '花絮中，导演亲自上阵示范如何站位与走位，现场笑声不断。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20filming%20equipment%20and%20lighting%20rigs%20on%20a%20rooftop%20at%20golden%20hour%20with%20magenta%20sky%2C%20editorial%20behind%20the%20scenes%20news%2C%20cinematic%20warm%20tone&width=800&height=500&seq=gossip-body-a11&orientation=landscape', caption: '天台的布光现场（示意图）' },
      { type: 'paragraph', text: '该片段上线后，被网友称为\"年度最心动镜头之一\"。' },
    ],
  },
  {
    id: 'a12',
    title: '网络热议：顶流账号疑似\"开小号\"，深夜点赞前队友',
    summary: '网友发现某顶流疑似经营着一个未认证小号，并被扒出深夜点赞前队友动态。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20smartphone%20screen%20glowing%20with%20abstract%20social%20media%20interface%20blur%20in%20warm%20magenta%20and%20orange%20tones%20on%20dark%20background%2C%20editorial%20tech%20gossip%20aesthetic&width=800&height=600&seq=gossip-cover-a12&orientation=landscape',
    category: 'leak',
    categoryName: '热门爆料',
    sub: '网络热议',
    source: '网友扒皮',
    author: '福尔摩斯网友',
    publishedAt: '2026-10-09 15:20',
    views: 158960,
    comments: 4470,
    tags: ['小号', '点赞', '前队友'],
    content: [
      { type: 'paragraph', text: '一位自称\"技术流\"的网友通过比对发文习惯、设备型号与IP段，指出某顶流疑似拥有一个长期活跃的未认证小号。' },
      { type: 'quote', text: '发文的时间点、表情符号用法几乎一模一样，这已经不是巧合的级别了。' },
      { type: 'paragraph', text: '最让粉丝炸锅的是，该小号被扒出曾在深夜点赞前队友的动态，而两人此前多次被传\"关系破裂\"。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20digital%20forensics%20concept%20with%20glowing%20magenta%20data%20lines%20and%20orange%20nodes%20on%20dark%20grid%2C%20editorial%20investigation%20aesthetic%2C%20abstract&width=800&height=500&seq=gossip-body-a12&orientation=landscape', caption: '网友整理的时间线比对图（示意）' },
      { type: 'paragraph', text: '目前该账号已设置为私密状态，相关话题的讨论仍在持续发酵。' },
    ],
  },
  {
    id: 'a13',
    title: '年度大瓜盘点：这一年娱乐圈到底发生了什么',
    summary: '从年初的惊天同框到年末的世纪和解，我们用一条时间线复盘这一整年的娱乐大事件。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20timeline%20collage%20concept%20with%20glowing%20magenta%20dots%20and%20orange%20lines%20on%20warm%20neutral%20background%2C%20editorial%20annual%20review%20poster%20aesthetic%2C%20modern%20geometric&width=800&height=600&seq=gossip-cover-a13&orientation=landscape',
    category: 'topic',
    categoryName: '专题合集',
    sub: '年度大瓜盘点',
    source: '编辑部',
    author: '大瓜年鉴',
    publishedAt: '2026-10-08 10:00',
    views: 312450,
    comments: 6890,
    tags: ['年度盘点', '时间线', '大事件'],
    content: [
      { type: 'paragraph', text: '这一年，娱乐圈的关键词是\"反转\"。从开年的惊天同框，到年中的连环塌房，再到年尾出人意料的世纪和解，几乎每个月都有让人措手不及的大瓜。' },
      { type: 'heading', text: '第一幕：开年惊雷' },
      { type: 'paragraph', text: '一场深夜同框，拉开了这出年度大戏的序幕。相关话题连续霸榜十一天，堪称年度最强开局。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20retro%20newspaper%20front%20pages%20stacked%20artistically%20with%20warm%20sepia%20tone%20and%20magenta%20highlights%2C%20editorial%20year%20review%20concept%2C%20minimal&width=800&height=500&seq=gossip-body-a13&orientation=landscape', caption: '年度关键词回顾（设计示意）' },
      { type: 'heading', text: '第二幕：连环塌房' },
      { type: 'paragraph', text: '年中开始，多位曾被视为\"口碑担当\"的艺人接连陷入争议，行业一度进入\"人人自危\"的状态。' },
      { type: 'heading', text: '第三幕：和解与重启' },
      { type: 'paragraph', text: '到了年尾，几对曾被传\"老死不相往来\"的组合意外同台，让不少网友感叹\"活久见\"。' },
    ],
  },
  {
    id: 'a14',
    title: '顶流塌房合集：那些一夜之间跌落神坛的名字',
    summary: '流量时代，人设的建立需要十年，崩塌可能只需要一条爆料。本期合集聚焦塌房背后的共性规律。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cracked%20marble%20statue%20head%20on%20warm%20gray%20background%20with%20magenta%20dramatic%20side%20light%2C%20symbolic%20editorial%20concept%2C%20minimal%20sculptural&width=800&height=600&seq=gossip-cover-a14&orientation=landscape',
    category: 'topic',
    categoryName: '专题合集',
    sub: '顶流塌房合集',
    source: '编辑部',
    author: '大瓜年鉴',
    publishedAt: '2026-10-08 09:20',
    views: 276310,
    comments: 5540,
    tags: ['塌房', '人设', '流量'],
    content: [
      { type: 'paragraph', text: '塌房从来不是偶然。翻看过去几年的案例，几乎都遵循着相似的剧本：人设过度完美、私德长期缺位、团队公关迟缓。' },
      { type: 'quote', text: '观众可以接受不完美，但不能接受被欺骗。这是所有塌房事件最核心的教训。' },
      { type: 'paragraph', text: '本专题梳理了数起标志性事件，从时间线、舆论传播路径到最终的商业影响，逐一拆解。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20broken%20stage%20spotlight%20with%20warm%20orange%20beam%20and%20magenta%20dust%20particles%20on%20dark%20background%2C%20editorial%20concept%20photo%2C%20cinematic%20symbolic&width=800&height=500&seq=gossip-body-a14&orientation=landscape', caption: '象征性的舞台意象（设计示意）' },
      { type: 'paragraph', text: '值得注意的是，越来越多品牌开始在合约中加入\"道德条款\"，以规避艺人失德带来的风险。' },
    ],
  },
  {
    id: 'a15',
    title: '豪门恩怨编年史：一场持续二十年的家族风云',
    summary: '从联姻到反目，从分家到最后和解，这个家族的故事几乎涵盖了所有能拍成剧的桥段。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20grand%20old%20mansion%20hallway%20with%20warm%20golden%20chandelier%20and%20deep%20burgundy%20carpet%2C%20editorial%20dynasty%20story%20aesthetic%2C%20cinematic%20symmetrical&width=800&height=600&seq=gossip-cover-a15&orientation=landscape',
    category: 'topic',
    categoryName: '专题合集',
    sub: '豪门恩怨',
    source: '编辑部',
    author: '豪门观察',
    publishedAt: '2026-10-07 18:30',
    views: 198740,
    comments: 3980,
    tags: ['豪门', '家族', '恩怨'],
    content: [
      { type: 'paragraph', text: '如果把这个家族的故事写成剧本，大概没人会相信这是真事——联姻、反目、对簿公堂、再到出人意料的握手言和。' },
      { type: 'heading', text: '第一代：白手起家' },
      { type: 'paragraph', text: '故事的开端，是两位创始人从零开始打下的商业帝国，也正是这份家业，埋下了后续所有纷争的伏笔。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20antique%20family%20portrait%20frames%20on%20a%20warm%20wall%20with%20magenta%20dramatic%20lighting%2C%20editorial%20heritage%20story%20aesthetic%2C%20minimal%20concept&width=800&height=500&seq=gossip-body-a15&orientation=landscape', caption: '家族历史影像（设计示意）' },
      { type: 'paragraph', text: '二十年间，家族三代人之间的博弈，几乎每一次都牵动着财经与娱乐两个版面的头条。' },
    ],
  },
  {
    id: 'a16',
    title: '复出风云：那些消失后又悄然回来的人',
    summary: '有人高调宣布退圈，有人默默注销账号，但总有人在某个不知名的夜里，悄悄发布了第一条动态。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20empty%20stage%20with%20warm%20amber%20spotlight%20breaking%20through%20darkness%20and%20faint%20magenta%20haze%2C%20editorial%20comeback%20theme%20aesthetic%2C%20cinematic%20minimal&width=800&height=600&seq=gossip-cover-a16&orientation=landscape',
    category: 'topic',
    categoryName: '专题合集',
    sub: '复出风云',
    source: '编辑部',
    author: '回归档案',
    publishedAt: '2026-10-07 12:00',
    views: 167890,
    comments: 3020,
    tags: ['复出', '退圈', '回归'],
    content: [
      { type: 'paragraph', text: '娱乐圈的\"消失\"往往不是终点。有人因为争议退场，有人因为身体原因暂别，但真正彻底放下的人，其实少之又少。' },
      { type: 'quote', text: '舞台的诱惑太大了，只要还有一个人记得你，你就很难真的走远。' },
      { type: 'paragraph', text: '本专题记录了几位极具代表性的\"复出案例\"，复盘他们的回归时机、舆论环境与复出策略。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20backstage%20corridor%20with%20warm%20orange%20exit%20sign%20glow%20and%20magenta%20reflections%2C%20empty%20and%20cinematic%2C%20editorial%20comeback%20concept%20photo&width=800&height=500&seq=gossip-body-a16&orientation=landscape', caption: '舞台后台（设计示意）' },
      { type: 'paragraph', text: '有意思的是，选择\"深夜低调回归\"的艺人，往往比高调开发布会的人，走得更稳、更远。' },
    ],
  },
];